import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import UnauthenticatedRoutes from "./component/common/Routes/UnauthenticatedRoutes";
import AuthenticatedRoutes from "./component/common/Routes/AuthenticatedRoutes";
import CustomerAuthenticatedRoutes from "./component/common/Routes/CustomerAuthenticatedRoutes";
import VendorAuthenticatedRoutes from "./component/common/Routes/VendorAuthenticatedRoutes";

import { Box, CssBaseline } from "@mui/material";

import TopBar from "./component/common/components/TopBar";
import SideBar from "./component/common/components/SideBar";
import { useSelector } from "react-redux";
import "./App.css";
import {
  DASHBOARD,
  LOGIN,
  VENDOR_DASHBOARD
} from "./component/common/Routes/AppRoutes";
import { StyledBox } from "./Style.js";
import { CUSTOMER_DASHBOARD } from "./component/common/Routes/CustomerRoutes.js";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("accessToken")
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    setIsAuthenticated(!!token);
  }, [user]);

  const handleDrawerToggle = () => setIsDrawerOpen(!isDrawerOpen);
  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
  const handleCloseUserMenu = () => setAnchorElUser(null);

  const getDashboardRoute = () => {
    if (!user) return LOGIN;
    switch (user.role) {
      case "Admin":
        return DASHBOARD;
      case "Staff":
        return DASHBOARD;
      case "Customer":
        return CUSTOMER_DASHBOARD;
      case "Vendor":
        return VENDOR_DASHBOARD;
      default:
        return LOGIN;
    }
  };

  return (
    <Router>
      <Box className="main-header">
        <CssBaseline />
        {isAuthenticated && (
          <>
            <TopBar
              isDrawerOpen={isDrawerOpen}
              handleDrawerToggle={handleDrawerToggle}
              anchorElUser={anchorElUser}
              handleOpenUserMenu={handleOpenUserMenu}
              handleCloseUserMenu={handleCloseUserMenu}
            />
            <SideBar
              userRole={user?.role}
              isDrawerOpen={isDrawerOpen}
              handleDrawerToggle={handleDrawerToggle}
            />
          </>
        )}
        <StyledBox
          isAuthenticated={isAuthenticated}
          className={
            isAuthenticated ? "dashboard-main-content" : "auth-container"
          }
        >
          <Routes>
            {!isAuthenticated ? (
              <Route path="/*" element={<UnauthenticatedRoutes />} />
            ) : (
              <>
                <Route
                  path="/"
                  element={<Navigate to={getDashboardRoute()} replace />}
                />
                {user?.role === "Customer" ? (
                  <Route path="/*" element={<CustomerAuthenticatedRoutes />} />
                ) : user?.role === "Vendor" ? (
                  <Route path="/*" element={<VendorAuthenticatedRoutes />} />
                ) : (
                  <Route path="/*" element={<AuthenticatedRoutes />} />
                )}
              </>
            )}
            <Route
              path="*"
              element={
                <Navigate
                  to={isAuthenticated ? getDashboardRoute() : LOGIN}
                  replace
                />
              }
            />
          </Routes>
        </StyledBox>
      </Box>
    </Router>
  );
};

export default App;
